// cookie-consent.component.ts
import { Component } from "@angular/core";
import { CookieConsentService } from "src/app/service/cookie-consent.service";

@Component({
  selector: "app-cookie-consent",
  templateUrl: "./cookie-consent.component.html",
  styleUrls: ["./cookie-consent.component.css"],
})
export class CookieConsentComponent {
  clicked = false;
  constructor(public cookieConsentService: CookieConsentService) {}

  acceptCookies() {
    this.cookieConsentService.setConsent(true);
    this.clicked = true;
  }

  denyCookies() {
    this.cookieConsentService.setConsent(false);
    (
      (
        document.getElementsByClassName("cookie-consent") as HTMLCollection
      )[0] as HTMLElement
    ).style.display = "none";
  }
}
